import { EmailIcon, FacebookIcon, LocationIcon, PhoneIcon } from '@/assets/icons';
import React from 'react';
import logo from '../../../public/logo-hori-white.png';
import Image from 'next/image';
import { NavLink } from './Header';
import Link from 'next/link';
import { COMPANY_ADDRESSES } from '@/constants/companyInfo';

const CONTACT_ITEMS = [
  {
    icon: <PhoneIcon className="min-w-6" />,
    label: 'Hotline',
    value: '083 419 4986',
  },
  {
    icon: <PhoneIcon className="min-w-6" />,
    label: 'Zalo',
    value: '083 419 4986',
  },
  {
    icon: <EmailIcon className="min-w-6" />,
    label: 'Email',
    value: 'truongthofood68@gmail.com',
  },
];

const Footer = () => {
  return (
    <div className="bg-gradient-to-br from-secondary to-secondary/90 text-white py-8 md:py-11">
      <div className="container flex flex-col w-full gap-8">
        <div>
          <Image alt="Logo Trường Thọ Food - Công ty trứng gà uy tín" src={logo} height={30} width={110} />
        </div>
        <div className="flex md:flex-row flex-col w-full gap-11">
          <div className="flex flex-col gap-4 w-full md:min-w-[488px]">
            <div className="font-bold text-[20px] uppercase">
              CÔNG TY TNHH TM DV THỰC PHẨM TRƯỜNG THỌ
            </div>

            <div className="flex flex-col gap-2 text-[18px]">
              <div className="flex items-start w-fit gap-2">
                <LocationIcon className="min-w-6" />
                <div className="flex flex-col">
                  {COMPANY_ADDRESSES.map((address) => (
                    <p key={address.id}>
                      {address.label
                        ? `${address.label}: ${address.fullAddress}`
                        : address.fullAddress}
                    </p>
                  ))}
                </div>
              </div>
              {CONTACT_ITEMS.map((item) => (
                <div
                  key={item.label}
                  className="flex items-center w-fit gap-2"
                >
                  {item.icon}
                  <p>
                    {item.label}: {item.value}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4 w-full">
            <div className="font-bold text-[20px] uppercase">Thông tin</div>
            <div className="flex flex-col gap-2 text-[18px]">
              {NavLink.map((item, index) => (
                <Link href={item.href} key={index} className="hover:underline">
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4 w-full">
            <div className="font-bold text-[20px] uppercase">
              Kết nối với chúng tôi
            </div>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61586714805618"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Kết nối với Trường Thọ Food trên Facebook"
                className="flex h-10 w-10 items-center justify-center border-white border rounded-full text-primary hover:bg-primary hover:text-white duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-secondary"
              >
                <FacebookIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
        <div className="h-[1px] w-full bg-white" />
        <div className="flex md:flex-row flex-col justify-between w-full">
          <Link href={'/'} className=" text-white hover:underline">
            Chính sách quyền riêng tư
          </Link>
          <p>
            Copyright © 2025 Truong Tho Food. All
            rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
